(function () {
    'use strict';

    angular.module('sempraWebapp').controller('TransactionsController', TransactionsController);

    /** @ngInject */
    function TransactionsController() {

        var vm = this;

        vm.isSelectedUser = false;

        vm.userSelected = function() {
            vm.isSelectedUser = true;
		};
        
    }
})();
